/**
 * BrandMark — marca de producto SOA 10 PRO, símbolo «Estados» del Portal.
 *
 * Contenedor cuadrado con radio 27 %, fondo blanco y borde interior de 1px
 * #DADDE3. Dos piezas, posicionadas en % del contenedor (README §1):
 *   - ficha cian #22D3EE · left 21 %, top 21 %, 58 × 40 %, radio 22 %
 *   - pastilla de acción #111318 · left 21 %, top 65 %, 27 × 14 %, radio 40 %
 * No cambiar el orden, no usar otros fondos que blanco / #0B0D10.
 *
 * `dark`: variante sobre oscuro (contenedor #16191F en el lockup, pastilla blanca).
 */
export function BrandSymbol({ size = 40, dark = false, className = "" }) {
  return (
    <span className={`relative inline-block flex-shrink-0 overflow-hidden ${className}`}
          style={{
            width: size, height: size, borderRadius: "27%",
            background: dark ? "#16191F" : "#FFFFFF",
            boxShadow: dark ? "none" : "inset 0 0 0 1px #DADDE3",
          }}
          aria-hidden="true">
      <span style={{ position: "absolute", left: "21%", top: "21%", width: "58%", height: "40%", borderRadius: "22%", background: "#22D3EE" }}/>
      <span style={{ position: "absolute", left: "21%", top: "65%", width: "27%", height: "14%", borderRadius: "40%", background: dark ? "#FFFFFF" : "#111318" }}/>
    </span>
  );
}

/**
 * Lockup «Portal Cliente» — símbolo de 40px sobre #FFFFFF dentro de una barra
 * #F2F3F6, texto en Figtree 900 (-0.03em, line-height .95) y bajada
 * «THE CREW AGENCIA». Sobre claro: #111318 + #0E7490.
 */
export default function BrandLockup({ size = 20, bar = true, className = "" }) {
  const inner = (
    <>
      <BrandSymbol size={40}/>
      <span className="flex flex-col" style={{ gap: 3 }}>
        <span style={{ fontWeight: 900, letterSpacing: "-0.03em", lineHeight: 0.95, fontSize: size, color: "#111318" }}>
          Portal <span style={{ color: "#0E7490" }}>Cliente</span>
        </span>
        <span style={{ fontWeight: 600, fontSize: size * 0.3 < 12 ? 12 : size * 0.3, color: "#5B5E68", lineHeight: 1, letterSpacing: "0.04em" }}>THE CREW AGENCIA</span>
      </span>
    </>
  );
  if (!bar) return <span className={`inline-flex items-center gap-3 ${className}`}>{inner}</span>;
  return (
    <span className={`inline-flex items-center gap-3 rounded-[20px] px-3 py-2.5 ${className}`} style={{ background: "#F2F3F6" }}>
      {inner}
    </span>
  );
}
